import PurchaseMethodsModelV25 from 'commons-vehicle/PurchaseMethodsV25/models/PurchaseMethodsModelV25.js';
import * as purchaseMethodsTypesV25 from 'commons-vehicle/PurchaseMethodsV25/actions/purchaseMethodsActionTypesV25.js';

export default function purchaseMethodReducerV25(state = new PurchaseMethodsModelV25(), action) {
    switch (action.type) {
        case purchaseMethodsTypesV25.LOAD_PURCHASE_METADATA_SUCCESS:
            return state.set('paymentOptionsMetadata', action.paymentOptionsMetadata);

        case purchaseMethodsTypesV25.LOAD_PURCHASE_METHODS_SUCCESSV25: {
            let payload = action.purchaseMethodsV25;
            if (!(payload instanceof PurchaseMethodsModelV25)) payload = new PurchaseMethodsModelV25(payload);
            return payload;
        }

        case purchaseMethodsTypesV25.SET_PAYMENT_OPTIONS_FETCH_STATUS: {
            return state.set('paymentOptionsFetchStatus', action.status);
        }

        default:
            return state;
    }
}
